import {Skeleton} from '@dropbox/dig-components/skeleton';
import noThumbnailImage from 'assets/images/default_thumbnail.png';
import classNames from 'classnames';
import {useRef, useState} from 'react';
import {getBackendUrl} from 'utilities';

import styles from './NewsThumbnail.module.css';

export const NewsThumbnail = ({
  id,
  onLoaded,
  isNewsFeed = false,
  isSmall = false,
  src,
}: {
  id: number;
  isNewsFeed?: boolean;
  src?: string;
  isSmall?: boolean;
  onLoaded?: (hasThumbnail: boolean) => void;
}) => {
  const time = useRef(new Date().getTime());
  const [loaded, setLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const skeletonSize = {height: '64px', width: '98px'};

  const url = getBackendUrl() + `/api/v1/news/thumbnail/${id}?t=${time.current}`;

  return (
    <div
      className={classNames(
        styles.image,
        isSmall ? styles.smallLandscape : styles.landscape,
        isNewsFeed ? styles.feed : styles.modify
      )}
    >
      <img
        style={{
          visibility: loaded ? 'visible' : 'hidden',
          opacity: loaded ? '1' : '0',
          objectFit: 'cover',
        }}
        onLoad={() => {
          setLoaded(true);
          onLoaded?.(true);
        }}
        onError={() => {
          setHasError(true);
          setLoaded(true);
          onLoaded?.(false);
        }}
        src={src ? src : hasError ? noThumbnailImage : url}
        loading="lazy"
      />
      <Skeleton.Box
        className={styles.skeleton}
        style={{
          ...skeletonSize,
          visibility: !loaded ? 'visible' : 'hidden',
          opacity: !loaded ? '1' : '0',
        }}
      />
    </div>
  );
};
